import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Action, Dispatch } from "redux";
import { AuthState } from "src/presentation/store/auth_state";
import { Customer } from "../../domain/model/customer";
import { entity } from "../../infra/api/rpc/api";
import { createAppNotificationMessageActionCreator } from "../action/app_notification_message_action";
import { createCustomerMessageRoomsActionCreator } from "../action/customer_message_rooms_action";
import { createCustomerMessageRoomActionCreator } from "../action/customer_message_room_action";
import CustomerMessageRoomsComponent from "../component/customer/message_rooms/customer_message_rooms";
import {
  createAppNotificationMessageDispatcher,
  IAppNotificationMessageDispatcher,
} from "../dispatcher/app_notification_message_dispatcher";
import {
  createCustomerMessageRoomsDispatcher,
  ICustomerMessageRoomsDispatcher,
} from "../dispatcher/customer_message_rooms_dispatcher";
import {
  createCustomerMessageRoomDispatcher,
  ICustomerMessageRoomDispatcher,
} from "../dispatcher/customer_message_room_dispatcher";
import { AppState } from "../store/app_state";
import { CustomerMessageRoomsState } from "../store/customer_message_rooms_state";
import { CustomerMessageRoomState } from "../store/customer_message_room_state";

interface IProps {
  messageRoomsState: CustomerMessageRoomsState;
  messageRoomState: CustomerMessageRoomState;
  messageRoomsDispatcher: ICustomerMessageRoomsDispatcher;
  messageRoomDispatcher: ICustomerMessageRoomDispatcher;
  notificationDispatcher: IAppNotificationMessageDispatcher;
  history: any;
  match: any;
  authState: AuthState;
}

interface IState {
  isInit: boolean;
}

export class CustomerMessageRooms extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    this.props.messageRoomsDispatcher.startPollingMessageRooms();
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.messageRoomsState.isLoading &&
      prevProps.messageRoomsState.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public componentWillUnmount() {
    this.props.messageRoomsDispatcher.stopPollingMessageRooms();
  }

  public render(): JSX.Element {
    const {
      messageRoomsState,
      messageRoomState,
      messageRoomDispatcher,
      messageRoomsDispatcher,
      notificationDispatcher,
      match,
      authState,
    } = this.props;
    const { isInit } = this.state;

    const customer: Customer | null = authState.user && authState.user.customer;
    if (customer!.type === entity.Customer.Type.Type_Pro) {
      return <Redirect to="/" />;
    }

    return (
      <CustomerMessageRoomsComponent
        messageRoomsState={messageRoomsState}
        messageRoomState={messageRoomState}
        messageRoomsDispatcher={messageRoomsDispatcher}
        messageRoomDispatcher={messageRoomDispatcher}
        notificationDispatcher={notificationDispatcher}
        contracts={messageRoomsState.contracts}
        isInit={isInit}
        match={match}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    messageRoomsState: state.customerMessageRoomsReducer,
    messageRoomState: state.customerMessageRoomReducer,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    messageRoomsDispatcher: createCustomerMessageRoomsDispatcher(
      dispatch,
      createCustomerMessageRoomsActionCreator()
    ),
    messageRoomDispatcher: createCustomerMessageRoomDispatcher(
      dispatch,
      createCustomerMessageRoomActionCreator()
    ),
    notificationDispatcher: createAppNotificationMessageDispatcher(
      dispatch,
      createAppNotificationMessageActionCreator()
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerMessageRooms);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_message_rooms_container.tsx